/**
 * Given a select menu `change` event, either reveal or hide certain
 * elements and ensure relevant input elements are disabled (or not).
 *
 * @param {Event} event
 */
function revealBySelectMenu(event) {
	// We might have previously revealed an element and we don't yet
	// know what path we'll be taking given this event, so we'll start
	// by "resetting" things and hiding the relevant element.
	// This depends on only having one such hidden element per step.
	let revealElement = this.currentStepElement.querySelector('.js-reveal-by-select-menu');

	if (revealElement) {
		revealElement.classList.add('js-hide', 'invisible');

		for (let inputElement of revealElement.querySelectorAll('input')) {
			inputElement.disabled = true;
		}
	}

	const selectedAnswer = event.target.options[event.target.selectedIndex];

	if (!selectedAnswer || !selectedAnswer.value) {
		return;
	}

	const revealId = selectedAnswer.dataset.revealTargetId

	if (!revealId) {
		return;
	}

	revealElement = this.currentStepElement.querySelector(`#${revealId}`);

	if (revealElement) {
		revealElement.classList.remove('js-hide', 'invisible');

		for (let inputElement of revealElement.querySelectorAll('input')) {
			inputElement.disabled = false;
		}

		console.log('Select menu revealed element:', revealElement);
	}
}

export {
	revealBySelectMenu
}